const SERVICES = [
  {
    tag: "WEB & MOBILE",
    tagColor: "text-pink-300",
    title: "Websites & Mobile Apps",
    desc: "Full-stack web software, dynamic interfaces, and native mobile applications.",
    img: "https://images.pexels.com/photos/27141314/pexels-photo-27141314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Ultra-modern web dashboard with vibrant neon UI elements",
  },
  {
    tag: "AI WORKFLOWS",
    tagColor: "text-violet-300",
    title: "AI Chatbots & LLMs",
    desc: "Intelligent virtual assistants, automated query pipelines, and custom bots.",
    img: "https://images.pexels.com/photos/30530407/pexels-photo-30530407.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "AI chatbot interface with real-time prompt generation stream",
  },
  {
    tag: "ALGORITHMS",
    tagColor: "text-cyan-300",
    title: "Matlab & Python Computing",
    desc: "Simulation models, Mathematica formulas, and quantitative data pipelines.",
    img: "https://images.pexels.com/photos/5775/calculator-scientific.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Matlab and Python scientific computing graphs and matrices",
  },
  {
    tag: "ACADEMIC",
    tagColor: "text-rose-300",
    title: "Articles & PhD Proposals",
    desc: "Rigorous research writing, thesis drafts, and precision LaTeX typesetting.",
    img: "https://images.pexels.com/photos/9572697/pexels-photo-9572697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Graduate research paper and LaTeX manuscript layout",
  },
  {
    tag: "ONLINE TUTORING",
    tagColor: "text-emerald-300",
    title: "Math, Stats & Physics",
    desc: "One-on-one virtual mentoring for complex mathematics, statistics, and physics.",
    img: "https://images.pexels.com/photos/6326382/pexels-photo-6326382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Virtual whiteboard tutoring session for mathematics and physics",
  },
  {
    tag: "EXPEDITE",
    tagColor: "text-amber-300",
    title: "Urgent Turnaround Help",
    desc: "Rapid emergency assistance for impending academic submissions and bugs.",
    img: "https://images.pexels.com/photos/29218404/pexels-photo-29218404.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Fast turnaround deadline countdown and support dispatch",
  },
];

const ServiceGrid = () => (
  <section id="services" className="py-24 px-6 border-b border-white/5" data-testid="services-section">
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div>
          <span className="text-xs font-mono uppercase tracking-widest text-pink-400">Delivery Spectrum</span>
          <h2 className="font-poster text-4xl sm:text-5xl uppercase tracking-normal text-white mt-1">
            Virtual Solutions Matrix
          </h2>
        </div>
        <p className="text-sm text-slate-400 max-w-sm">
          From urgent programming to comprehensive academic guidance.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {SERVICES.map((s, i) => (
          <div
            key={s.title}
            data-testid={`service-card-${i + 1}`}
            className="p-6 rounded-2xl bg-[#171324] border border-white/10 group hover:border-pink-500/40 transition-colors"
          >
            <div className="aspect-[16/10] rounded-xl overflow-hidden mb-6 border border-white/10 relative">
              <img
                src={s.img}
                alt={s.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover drift-frame"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#110e1a]/80 via-transparent to-transparent" />
              <div className={`absolute bottom-3 left-3 text-xs font-mono ${s.tagColor} bg-black/60 px-2 py-0.5 rounded`}>
                {s.tag}
              </div>
            </div>
            <h3 className="font-poster text-2xl uppercase tracking-wide text-white mb-1">{s.title}</h3>
            <p className="text-xs text-slate-400 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceGrid;
